module.exports = __webpack_public_path__ + "static/media/sfx_amb_fades_02.157bd7af.mp3";